/* Oferta de bienvenida.
   - Cualquier enlace a #bienvenida (o [data-welcome-open]) abre el pop-up: el de Klaviyo si hay ID en el tema,
     si no el propio del tema (#WelcomePopup); sin ninguno, baja a #bienvenida o al alta del pie.
   - El pop-up propio sale solo una vez por visitante (a los N segundos o al bajar media página).
   - Al enviar: email a Klaviyo (evento "Oferta de bienvenida" y alta en la lista si la hay), se aplica el código
     (/discount/CÓDIGO deja la cookie discount_code) y se guarda el regalo elegido para el carrito. */
(function () {
  var cfg = window.pmWelcome || {};
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var pop = document.getElementById('WelcomePopup');
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var lastFocus = null;

  function step(n) {
    ['0', '1', 'wa', '2'].forEach(function (k) { var el = pop.querySelector('[data-wp-step="' + k + '"]'); if (el) el.hidden = k !== String(n); });
  }
  /* auto: sale solo, empieza con la pregunta. Si lo abre un botón, va directo al formulario. */
  function showPop(auto) {
    if (!pop) return false;
    lastFocus = document.activeElement;
    var done = store.get('pmWelcomeDone');
    step(done ? 2 : (auto ? 0 : 1));
    if (done) fillStep2();
    pop.hidden = false;
    document.documentElement.classList.add('pm-wp-open');
    pop.querySelector('.pm-wp__panel').focus({ preventScroll: true });
    store.set('pmWelcomeSeen', String(Date.now()));
    return true;
  }
  function hidePop() {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    document.documentElement.classList.remove('pm-wp-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openOffer() {
    if (cfg.form && window._klOnsite) { window._klOnsite.push(['openForm', cfg.form]); return true; }
    if (showPop()) return true;
    var el = document.getElementById('bienvenida') || document.getElementById('FooterNewsletter');
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var input = el.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 700);
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wp-close]')) { hidePop(); return; }
    if (e.target.closest('[data-wp-yes]')) {
      step(1);
      var em = pop.querySelector('input[type="email"]'); if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, 50);
      return;
    }
    var copy = e.target.closest('[data-wp-copy]');
    if (copy) {
      var code = pop.getAttribute('data-code');
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { copy.textContent = 'Copiado'; }, function () {});
      return;
    }
    var a = e.target.closest('a[href$="#bienvenida"], [data-welcome-open]');
    if (!a || !openOffer()) return;
    e.preventDefault();
    var cd = document.getElementById('CartDrawer');
    if (cd && !cd.hidden) { var x = cd.querySelector('[data-cd-close]'); if (x) x.click(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hidePop(); });

  function fillStep2() {
    var name = store.get('pmWelcomeGiftName') || 'los tres sabores';
    var n = pop.querySelector('[data-wp-gift-name]'); if (n) n.textContent = /mix/i.test(name) ? 'los tres sabores' : name;
  }
  function applyCode(code) {
    if (!code) return Promise.resolve();
    return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  }

  if (pop) {
    var form = pop.querySelector('[data-wp-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = pop.querySelector('[data-wp-msg]');
      var email = (form.email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.textContent = 'Revisa el email.'; form.email.focus(); return; }
      if (!form.consent.checked) { msg.textContent = 'Marca la casilla para poder enviarte el código.'; return; }
      msg.textContent = '';
      var gift = form.querySelector('input[name="gift"]:checked');
      var giftId = gift ? gift.value : '';
      var giftName = gift ? gift.getAttribute('data-name') : '';
      var code = pop.getAttribute('data-code');
      var key = pop.getAttribute('data-key'), list = pop.getAttribute('data-list');
      var btn = form.querySelector('[type="submit"]'); btn.setAttribute('aria-busy', 'true');
      var reqs = [];
      if (key) {
        var headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };
        var base = 'https://a.klaviyo.com/client/';
        reqs.push(fetch(base + 'events/?company_id=' + encodeURIComponent(key), { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'event', attributes: { properties: { regalo: giftName, codigo: code }, metric: { data: { type: 'metric', attributes: { name: 'Oferta de bienvenida' } } }, profile: { data: { type: 'profile', attributes: { email: email, properties: { regalo_bienvenida: giftName } } } } } } }) }).catch(function () {}));
        if (list) reqs.push(fetch(base + 'subscriptions/?company_id=' + encodeURIComponent(key), { method: 'POST', headers: headers, body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } }) }).catch(function () {}));
      }
      reqs.push(applyCode(code));
      store.set('pmWelcomeDone', '1'); store.set('pmWelcomeGiftOff', '0');
      if (giftId) { store.set('pmWelcomeGift', giftId); store.set('pmWelcomeGiftName', giftName); }
      Promise.all(reqs).then(function () {
        btn.removeAttribute('aria-busy');
        lastEmail = email;
        step('wa');
        pop.querySelector('.pm-wp__panel').focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('pm:welcome', { detail: { gift: giftId } }));
      });
    });

    /* Paso de WhatsApp (opcional): el móvil va a Klaviyo con su consentimiento; sin móvil, directo al código */
    var lastEmail = '';
    function toCode() { step(2); fillStep2(); pop.querySelector('.pm-wp__panel').focus({ preventScroll: true }); }
    pop.querySelector('[data-wp-skip-wa]').addEventListener('click', toCode);
    var waForm = pop.querySelector('[data-wp-wa-form]');
    waForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = pop.querySelector('[data-wp-wa-msg]');
      var phone = (waForm.phone.value || '').replace(/[\s.\-()]/g, '');
      if (/^[67]\d{8}$/.test(phone)) phone = '+34' + phone;
      else if (/^00\d+/.test(phone)) phone = '+' + phone.slice(2);
      if (!/^\+\d{9,15}$/.test(phone)) { msg.textContent = 'Revisa el móvil.'; waForm.phone.focus(); return; }
      if (!waForm.wa_consent.checked) { msg.textContent = 'Marca la casilla para poder enviártelo por WhatsApp.'; return; }
      msg.textContent = '';
      var key = pop.getAttribute('data-key');
      var done = function () { store.set('pmWelcomeWhatsapp', '1'); toCode(); };
      if (!key || !lastEmail) { done(); return; }
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify({ data: { type: 'event', attributes: { properties: { whatsapp: phone, codigo: pop.getAttribute('data-code') }, metric: { data: { type: 'metric', attributes: { name: 'Oferta de bienvenida WhatsApp' } } }, profile: { data: { type: 'profile', attributes: { email: lastEmail, properties: { whatsapp_bienvenida: phone, whatsapp_consentimiento: true, whatsapp_consentimiento_fecha: new Date().toISOString() } } } } } } }) }).catch(function () {}).then(done);
    });

    /* Sale solo: una vez por visitante, ni en el carrito ni si ya pidió su código */
    var auto = pop.getAttribute('data-auto') === 'true';
    var seen = store.get('pmWelcomeSeen'), done = store.get('pmWelcomeDone');
    if (auto && !seen && !done && !/\/(cart|checkouts?|account)/.test(location.pathname) && location.hash !== '#bienvenida') {
      var fired = false;
      var fire = function () {
        if (fired) return; fired = true;
        window.removeEventListener('scroll', onScroll);
        var cd = document.getElementById('CartDrawer');
        if (cd && !cd.hidden) return;
        showPop(true);
      };
      var onScroll = function () { if (window.scrollY > (document.documentElement.scrollHeight - window.innerHeight) * 0.5) fire(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(fire, (+pop.getAttribute('data-delay') || 10) * 1000);
    }
  }

  if (location.hash === '#bienvenida') window.addEventListener('load', function () { setTimeout(openOffer, 400); });
})();
